<template>
    <div class="reference-bottom-sheet" :style="props.positionStyle" ref="bottomSheetRef">
        <p class="title h4">{{ t('trend_report_measure_num_modal_title') }}</p>
        <p class="sub-title body-3--regular">
            {{ t('trend_report_measure_num_modal_desc') }}
        </p>
        <div class="evaluation-desc-wrap">
            <p class="body-3">{{ t('trend_report_evaluation_modal_sub_title_1') }}</p>
            <img
                src="../../../public/assets/images/change-status.png"
                :alt="t('trend_report_evaluation_modal_chart_image_alt')"
            />
            <p
                class="img-caption caption--regular"
                v-dompurify-html="t('trend_report_measure_num_modal_chart_image_caption')"
            ></p>
            <p class="body-3--regular padding-bottom">
                {{ t('trend_report_measure_num_modal_body_1_text_1') }}
            </p>
            <p class="body-3--regular" v-dompurify-html="t('trend_report_measure_num_modal_body_1_text_2')"></p>
        </div>
        <button class="close-btn h6" @click="handleCloseBtnClick">닫기</button>
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const emit = defineEmits(['close']);

const props = defineProps<{
    positionStyle: string | Record<string, string>;
}>();

const bottomSheetRef = ref<HTMLElement | null>(null);

const handleCloseBtnClick = () => {
    emit('close');
};

let justOpened = false;

const handleClickOutside = (e: MouseEvent) => {
    if (justOpened) {
        justOpened = false;
        return; // 첫 클릭은 무시
    }

    const el = bottomSheetRef.value;
    if (
        el &&
        !el.contains(e.target as Node) &&
        !(e.target as HTMLElement).classList.contains('evaluation-title-box') &&
        !(e.target as HTMLElement).classList.contains('evaluation-title-text')
    ) {
        emit('close');
    }
};

onMounted(() => {
    justOpened = true; // 마운트 되자마자 한 번은 무시
    document.addEventListener('click', handleClickOutside);
});

onBeforeUnmount(() => {
    document.removeEventListener('click', handleClickOutside);
});
</script>

<style scoped lang="scss">
.reference-bottom-sheet {
    position: sticky;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 3rem 1.5rem;
    box-shadow: 0px -20px 20px 0px #0000000d;
    background-color: $primary-white;
    border-radius: 2.5rem 2.5rem 0 0;
    z-index: 100;
    max-height: 60%;
    overflow-y: auto;
}

.title {
    padding-bottom: 0.5rem;
    color: $grey-7;
    line-height: 170%;
}

.sub-title {
    color: $grey-7;
}

.close-btn {
    background: $grey-2;
    border-radius: 1.5rem;
    padding: 1.3rem 0;
    width: 45%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    margin-top: 2rem;
    color: $grey-7;
}

.evaluation-reason-list {
    color: $grey-7;
}

.evaluation-desc-wrap {
    color: $grey-7;
    padding-top: 2rem;

    > p {
        white-space: pre-line;
        word-break: break-all;
    }

    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        margin-top: 1.7rem;
    }

    .img-caption {
        line-height: 150%;
        color: $grey-6;
        text-align: right;
        margin-bottom: 1.7rem;
    }

    .padding-bottom {
        padding-bottom: 3rem;
    }
}

.body-3--regular {
    white-space: pre-line;
    word-break: keep-all;

    :deep(.underline) {
        text-decoration: underline;
    }
}
</style>
